/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RestoreTargetDataFromDelete$Params {
  patientTargetDataID?: number;
}

export function RestoreTargetDataFromDelete(http: HttpClient, rootUrl: string, params?: RestoreTargetDataFromDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, RestoreTargetDataFromDelete.PATH, 'post');
  if (params) {
    rb.query('patientTargetDataID', params.patientTargetDataID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

RestoreTargetDataFromDelete.PATH = '/api/Staff/RestoreTargetDataFromDelete';
